import React from'react';import PropTypes from'prop-types';/**
 * @param {props} The component props
 * @returns {JSX}
 */var Spacer=function Spacer(_ref){var children=_ref.children,className=_ref.className;return React.createElement("div",{className:className},children);};Spacer.defaultProps={children:null,className:null};export default Spacer;